import styles from './summary-details.module.scss';
import { ISummaryPageSettings } from '../../../models/summary/ISummaryPageSettings';
import { ISummaryData } from '../../../models/summary/ISummaryData';
import { ISummaryContent } from '../../../models/summary/ISummaryContent';
import SummaryDegreeList from '../../../components/molecules/summary-degree-list/summary-degree-list';
import { ISummaryCourse } from '../../../models/summary/ISummaryCourse';
import { StudentType } from '../../../constants/student-type';

export type Props = {
  summaryPageSettings: ISummaryPageSettings;
  summaryData: ISummaryData[];
  summaryContent: ISummaryContent;
  studentLevel?: StudentType;
  application: string;
  googleTagId?: string;
  courseList?: ISummaryCourse[];
  summaryDetailsTitle: string;
};

export default function SummaryDetails({
  summaryPageSettings,
  summaryData,
  summaryContent,
  studentLevel,
  application,
  googleTagId,
  courseList,
  summaryDetailsTitle,
}: Props) {
  return (
    <div className={styles[`summary-details`]} id='degree-summary'>
      <div className={styles[`summary-title`]}>
        <h3>{summaryDetailsTitle}</h3>
        {!!summaryData && summaryData.length > 0 && (
          <SummaryDegreeList
            degrees={summaryData}
            pagingLimit={10}
            summaryPageSettings={summaryPageSettings}
            brandName={summaryContent.brand.fields.brandName}
            studentLevel={studentLevel}
            application={application}
            googleTagId={googleTagId}
            courseList={courseList}
          />
        )}
      </div>
    </div>
  );
}
